import { render } from "./CommandMessage.vue?vue&type=template&id=231b647e&ts=true"
import script from "./CommandMessage.vue?vue&type=script&lang=ts"
export * from "./CommandMessage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__